import { useEffect, useRef } from 'react';

interface AdmiralCmpProps {
  admiralUrl: string;
  enabled?: boolean;
}

export const AdmiralCmp = ({ admiralUrl, enabled }: AdmiralCmpProps) => {
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    if (!enabled) return;

    // Check if this exact script already exists
    const existingScript = document.querySelector(`script[src="${admiralUrl}"]`);
    if (existingScript) {
      scriptRef.current = existingScript as HTMLScriptElement;
      return;
    }

    const script = document.createElement('script');
    script.src = admiralUrl;
    script.dataset.admiralCmp = 'true'; // Mark it for identification that this has been injected by the bootstrap script
    document.head.prepend(script);
    scriptRef.current = script;

    // Cleanup: only remove if we created it AND it's still in the DOM
    return () => {
      if (scriptRef.current && scriptRef.current.parentNode === document.head) {
        document.head.removeChild(scriptRef.current);
      }
      scriptRef.current = null;
    };
  }, [enabled, admiralUrl]);

  return null;
};
